//import Vue from 'vue';
import { createPinia } from 'pinia'
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import './router/public-path.js'
import app from './app.vue';
import router from './router';
import { useLoanEnquiryStore } from './stores/loan-enquiry-store.js';
import generic from '@/shared/utils/generic.js';
import opmGeneric from './utils/generic.js';
import vuetify from '../../plugins/vuetify';

import { createApp } from 'vue'

/// String Prototype Format
/// usage: "Goodbye {0}, Hello {1} ".format("winter", "summer")
/// ***************************
if (!String.prototype.format) {
  String.prototype.format = function () {
    var args = arguments;
    return this.replace(/{([0-9]+)}/g, function (match, index) {
      return typeof args[index] == 'undefined' ? match : args[index];
    });
  };
}

/// String Prototype startsWith 
/// *******************************
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.toLowerCase().substr(position, searchString.length) === searchString.toLowerCase();
  };
}

/// String Prototype toBool 
/// ************************************
if (!String.prototype.toBool) {
  String.prototype.toBool = function () {
    switch (this.toLowerCase().trim()) {
      case "true": case "yes": case "1": return true;
      case "false": case "no": case "0": case null: return false;
      default: return Boolean(this);
    }
  };
}

/// String Prototype isNumeric 
/// ************************************
if (!String.prototype.isNumeric) {
  String.prototype.isNumeric = function () {
    const v = Number(this.replace(/,/g, ''));
    return !isNaN(v);
  };
}

/// Date Prototype dateAdd 
/// ************************************
if (!Date.prototype.dateAdd) {
  Date.prototype.dateAdd = function (offset) {
    return new Date(new Date().setFullYear(new Date().getFullYear() + offset)).toISOString().substr(0, 10);
  };
}

/// Global Mixins
/// ******************
const mixin = {
  methods: {
    /// Open Modules Text
    omt(key, args) {
      const { loanEnquiryConfig } = useLoanEnquiryStore();      
      return opmGeneric.textValue(
        loanEnquiryConfig.DisplayTexts,
        loanEnquiryConfig.CreditUnionInfo,
        loanEnquiryConfig.Params,
        loanEnquiryConfig.ReferenceData,
        key, args);
    },
    /// Formats currency value to display in UI
    /// options: { local: "en-ie", precision: 2, prefix: "€" }
    formatCurrencyToUi(value, options) {
      return generic.formatCurrencyToUi(value, opmGeneric.currencyConfig(options));
    }
  }
};

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

// Create Vue App instance
const _app = createApp(app);
_app.use(router);
_app.use(pinia);
_app.use(vuetify);
_app.mixin(mixin);

// Mount app on router.onReady so that current route is available in first load
router.isReady().then(() => {
  // Mount on div app
  _app.mount('#app')
});